import React, { useState, useEffect } from "react";
import styles from "~/widgets/ConstructionBanner/ConstructionBanner.module.scss";

const STORAGE_KEY = "divide_ttrpg_banner_dismissed_2";

const ConstructionBanner: React.FC = () => {
  const [isDismissed, setIsDismissed] = useState(true); // Start hidden to avoid flash

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    setIsDismissed(dismissed === "true");
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setIsDismissed(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <span className={styles.icon}>🚧</span>
        <span className={styles.message}>
          This system is in active development. Both the online character sheet and rules are subject to change at any time. Please don't share without permission! (And beware of bugs! Download the characters you care about just in case with the export button 😅)
        </span>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className={styles.dismissButton}
        aria-label="Dismiss banner"
      >
        ✕
      </button>
    </div>
  );
};

export default ConstructionBanner;
